import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import logo from "@/assets/logo.png";

interface CTASectionProps {
  user: any;
  onGetStarted: () => void;
}

export const CTASection = ({ user, onGetStarted }: CTASectionProps) => {
  return (
    <section className="relative py-20 md:py-32 overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 bg-gradient-to-t from-primary/10 via-background to-background" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[400px] md:w-[600px] h-[400px] md:h-[600px] bg-gradient-to-t from-primary/20 to-transparent rounded-full blur-[100px]" />

      <div className="container relative z-10 px-4">
        <div className="max-w-4xl mx-auto text-center space-y-8 md:space-y-10">
          {/* Logo */}
          <div className="flex justify-center">
            <div className="relative">
              <div className="absolute inset-0 bg-primary/30 blur-3xl rounded-full scale-150" />
              <img src={logo} alt="KOSH" className="relative h-16 w-16 md:h-24 md:w-24 animate-float" />
            </div>
          </div>

          {/* Headline */}
          <div className="space-y-4">
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-balance px-2">
              Ready to Take Control of
              <br className="hidden sm:block" />
              <span className="text-gradient"> Your Business?</span>
            </h2>
            <p className="text-base md:text-xl text-muted-foreground max-w-2xl mx-auto px-4">
              Start tracking your daily sales and profit in minutes. No setup fees, no hidden charges.
            </p>
          </div>

          {/* CTA */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center px-4">
            <Button 
              size="lg" 
              onClick={onGetStarted}
              className="group text-base md:text-lg h-14 md:h-16 px-10 md:px-12 rounded-full bg-gradient-to-r from-primary to-primary-dark hover:from-primary-dark hover:to-primary shadow-xl shadow-primary/30 hover:shadow-2xl hover:shadow-primary/40 transition-all duration-300 w-full sm:w-auto"
            >
              {user ? "Go to Dashboard" : "Start Your Free Account"}
              <ArrowRight className="ml-2 h-5 w-5 md:h-6 md:w-6 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>

          {/* Final trust */}
          <p className="text-xs md:text-sm text-muted-foreground">
            No credit card required • Free forever plan • Cancel anytime
          </p>
        </div>
      </div>
    </section>
  );
};